export const LINEITEMS_DATAGRID_COLUMNKEYS = {
  NAME: 'NAME',
  TRACE_LEVEL_ID: 'TRACE_LEVEL_ID',
  TIMESTAMP: 'TIMESTAMP',
  DETAILS: 'DETAILS',
};
